<template>
  <div class="confirmation-card">
    <h4 class="confirm-title">{{ title }}</h4>
    <div class="confirm-info-item">
      <span class="info-label">讲者:</span>
      <span class="info-value">{{ getSpeakerName() }}</span>
    </div>
    <!-- <div class="confirm-info-item">
      <span class="info-label">医院:</span>
      <span class="info-value">{{ getHospitalName() }}</span>
    </div> -->
    <div class="confirm-info-item">
      <span class="info-label">会议日期:</span>
      <span class="info-value">{{ getMeetingDate() }}</span>
    </div>
    <div class="confirm-info-item">
      <span class="info-label">会议时间:</span>
      <span class="info-value">{{ getMeetingTime() }}</span>
    </div>
    <div class="confirm-info-item">
      <span class="info-label">会议类型:</span>
      <span class="info-value">{{ getMeetingType() }}</span>
    </div>
    <div class="confirm-info-item">
      <span class="info-label">会议形式:</span>
      <span class="info-value">{{ getMeetingFormat() }}</span>
    </div>
    <div class="confirm-info-item">
      <span class="info-label">讲者类型:</span>
      <span class="info-value">{{ getSpeakerType() }}</span>
    </div>
    <!-- <div class="confirm-info-item">
      <span class="info-label">当前处理人:</span>
      <span class="info-value">{{ getCurrentProcessor() }}</span>
    </div> -->
    <div class="confirm-info-item" v-if="!showNotice">
      <span class="info-label">申请人:</span>
      <span class="info-value">{{ this.meetingInfo.creator_name }}</span>
    </div>
    <div class="confirm-info-item" v-if="!showNotice">
      <span class="info-label">受邀联络员:</span>
      <span class="info-value">{{ this.meetingInfo.approver_name }}</span>
    </div>
    <div class="confirm-info-item" v-if="!showNotice">
      <span class="info-label">确认状态:</span>
      <span class="info-value">{{ getConfirmationStatus() }}</span>
      <span v-if="isSuperAdmin" class="copy-btn" @click="showStatusPopup = true">修改</span>
    </div>

    <div class="confirm-notice" v-if="showNotice">
      点击"确认提交"后，将进入邀约流程！
    </div>

    <!-- 状态选择popup -->
    <van-popup v-model:show="showStatusPopup" position="bottom" :safe-area-inset-bottom="true" round
      :teleport="teleportTarget">
      <div class="popup-header">
        <span class="popup-cancel" @click="showStatusPopup = false">取消</span>
        <span class="popup-title">选择状态</span>
        <span class="popup-confirm" @click="confirmStatusChange">确定</span>
      </div>
      <van-cell-group>
        <van-cell v-for="(label, key) in statusMap" :key="key" :title="label" clickable @click="selectedStatus = key">
          <template #right-icon>
            <van-icon name="success" v-if="selectedStatus === key" color="#145294" size="18" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import { showToast } from 'vant';
import axios from '@/api/axios';
import { ref } from 'vue';

export default {
  name: 'MeetingInfoCard',
  props: {
    meetingInfo: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: '会议信息'
    },
    showNotice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showStatusPopup: false,
      selectedStatus: this.meetingInfo.status || '',
      statusMap: {
        pending: '邀约中',
        confirmed: '待开展',
        completed: '已结束',
        cancelled: '已取消',
        cannot_attend: '无法参会'
      }
    };
  },
  computed: {
    teleportTarget() {
      return document.body;
    },
    isSuperAdmin() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return userInfo.isSuperAdmin;
    }
  },
  methods: {
    getSpeakerName() {
      // 适配MeetingApplication和MeetingConfirmation的数据结构
      if (!this.meetingInfo) {
        return '暂无专家';
      }
      if (this.meetingInfo.selectedExpert) {
        return this.meetingInfo.selectedExpert.name;
      } else if (this.meetingInfo.expert_names) {
        return this.meetingInfo.expert_names;
      } else if (this.meetingInfo.experts && this.meetingInfo.experts.length > 0) {
        return this.meetingInfo.experts.map(expert => expert.name).join(', ');
      }
      return '暂无专家';
    },

    getHospitalName() {
      // 适配MeetingApplication的数据结构
      if (!this.meetingInfo || !this.meetingInfo.selectedExpert) {
        return '';
      }
      return this.meetingInfo.selectedExpert.hospital || '未知医院';
    },
    getMeetingDate() {
      // 适配MeetingApplication和MeetingConfirmation的数据结构
      if (!this.meetingInfo) {
        return '时间未定';
      }
      if (this.meetingInfo.meetingDate) {
        return this.meetingInfo.meetingDate;
      } else if (this.meetingInfo.scheduled_time) {
        const date = new Date(this.meetingInfo.scheduled_time);
        return `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')}`;
      }
      return '时间未定';
    },
    getMeetingTime() {
      // 适配MeetingApplication和MeetingConfirmation的数据结构
      if (!this.meetingInfo) {
        return '时间未定';
      }
      if (this.meetingInfo.startTime && this.meetingInfo.endTime) {
        return `${this.meetingInfo.startTime}-${this.meetingInfo.endTime}`;
      } else if (this.meetingInfo.scheduled_time) {
        const startTime = new Date(this.meetingInfo.scheduled_time);
        const startFormatted = `${startTime.getUTCHours().toString().padStart(2, '0')}:${startTime.getUTCMinutes().toString().padStart(2, '0')}`;

        if (this.meetingInfo.end_time) {
          const endTime = new Date(this.meetingInfo.end_time);
          const endFormatted = `${endTime.getUTCHours().toString().padStart(2, '0')}:${endTime.getUTCMinutes().toString().padStart(2, '0')}`;
          return `${startFormatted}-${endFormatted}`;
        }

        return startFormatted;
      }
      return '时间未定';
    },
    getMeetingType() {
      // 适配不同数据结构的会议类型字段
      if (!this.meetingInfo) {
        return '';
      }
      return this.meetingInfo.meetingType || this.meetingInfo.meeting_type || '';
    },
    getSpeakerType() {
      // 适配不同数据结构的讲者类型字段
      if (!this.meetingInfo) {
        return '';
      }
      return this.meetingInfo.speakerType || this.meetingInfo.speaker_type || '';
    },
    getMeetingFormat() {
      // 适配不同数据结构的会议形式字段
      if (!this.meetingInfo) {
        return '';
      }
      return this.meetingInfo.meetingFormat || this.meetingInfo.meeting_format || '';
    },
    getCurrentProcessor() {
      // 适配不同数据结构的当前处理人字段
      if (!this.meetingInfo) {
        return '';
      }
      return this.meetingInfo.current_processor || '';
    },
    getConfirmationStatus() {
      // 显示会议确认状态
      if (!this.meetingInfo || !this.meetingInfo.status) {
        return '';
      }
      return this.statusMap[this.meetingInfo.status];
    },
    confirmStatusChange() {
      // 调用API更新状态
      this.updateMeetingStatus();
    },
    async updateMeetingStatus() {
      try {
        // 发送PUT请求更新会议状态，使用查询参数
        const response = await axios.put('/api/meetings/' + this.meetingInfo.id + '/status', {}, {
          params: {
            status: this.selectedStatus
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.status === 200) {
          // 更新本地状态
          this.meetingInfo.status = this.selectedStatus;
          this.showStatusPopup = false;

          // 显示成功提示
          showToast({
            message: `状态已更新为${this.statusMap[this.selectedStatus]}`,
            type: 'success'
          });
        } else {
          throw new Error(`更新状态失败: ${response.status}`);
        }
      } catch (error) {
        console.error('更新会议状态失败:', error);
        showToast({
          message: '更新状态失败，请重试',
          type: 'fail'
        });
      }
    }
  }
}
</script>

<style scoped>
.confirmation-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.confirm-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: left;
}

.confirm-info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.confirm-info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 14px;
  color: #666;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.copy-btn {
  font-size: 12px;
  color: #145294;
  background-color: #e8f4fd;
  padding: 2px 8px;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 10px;
  user-select: none;
  -webkit-user-select: none;
}

.confirm-notice {
  margin-top: 20px;
  padding: 10px;
  background-color: #f8f8f8;
  border-radius: 8px;
  font-size: 14px;
  color: #999;
  text-align: center;
}

/* popup样式 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 16px;
}

.popup-cancel {
  color: #999;
  padding: 4px 8px;
}

.popup-title {
  font-weight: bold;
  color: #333;
}

.popup-confirm {
  color: #145294;
  padding: 4px 8px;
}
</style>